import {
  User,
  UserFilterInputObject,
  UsersQueryVariables,
  useUsersQuery,
} from 'graphql-common';
import _get from 'lodash/get';
import { GetUrlParams } from '@lib/enums/urls';
import { ListQueryHookProps } from '../types';

export default function useSiteMembershipsQueryHook({
  additionalFilters,
  paginationParams,
}: ListQueryHookProps) {
  const page = _get(paginationParams, GetUrlParams.Page);
  const perPage = _get(paginationParams, GetUrlParams.PerPage);
  const orderingField = _get(paginationParams, GetUrlParams.OrderingField);
  const orderingDirection = _get(
    paginationParams,
    GetUrlParams.OrderingDirection,
  );
  const filters: UserFilterInputObject[] = [];
  if (additionalFilters?.length) {
    filters.push(...additionalFilters);
  }
  const usersQueryVariables: UsersQueryVariables = {
    filters,
    page: Number(page),
    limit: Number(perPage),
    includeTeamData: true,
  };
  if (orderingField && orderingDirection) {
    usersQueryVariables.sorts = {
      [orderingField]: orderingDirection,
    };
  }
  const usersQuery = useUsersQuery({
    fetchPolicy: 'cache-and-network',
    variables: usersQueryVariables,
  });
  const {
    loading: siteUsersLoading,
    data,
    previousData,
    refetch: refetchUsers,
  } = usersQuery;
  const queryData = data || previousData;
  const collection = _get(queryData, 'data.collection', []) as User[];
  const metadata = _get(queryData, 'data.metadata');
  const totalCount = _get(metadata, 'totalCount', 0);

  return {
    collection,
    previousData,
    refetchUsers,
    siteUsersLoading,
    totalCount,
  };
}
